export const GRAPHIC_TITLE = {
  byCompany:'Por Compañía',
  byOrigin:'Por Origen',
  byCD:'CD',
  byTD:'TD',
  byPRV:'PRV',
  bySELLER:'SELLER',
  byPlatform:'Según Plataforma',
  distributionByPlatform:'Distribución por plataforma'
};

export const DASHBOARD_PROPERTIES = {
  pie_percentage:'83%'
};

export const enabledStores = {
  PROMART: ['tracingPicking','dashboardStoreWithdrawalPending','discountReport'],
  HESA: ['tracingPicking','dashboardStoreWithdrawalPending'],
  OE: ['orderRegister'],
  SPSA: ['controlTower', 'todayPerformance','jokrStockControl','historicalControlTower','externalPicking','jokrInventory','merkaoStockControl', 'merkaoTripSettlement','inkafarmaOrders'],
  AGO: ['sellerControlTower']
}

export const EMBED_REPORTS = {
  pickingReport: "8a210a11-e5ac-410c-9a0d-83e5805248bd",
  logisticSellerCenterReport: "7e5b2b48-4c16-4f30-ab83-2baebed9baeb",
  agoraPayReport:"8e644aca-5af6-44e6-baef-1f2e330da044",
  storeWithdrawal: "2164eef0-603f-4fd9-9d6e-8690e5e03705",
  transportReport: "61a823eb-f81b-4167-94fd-bfe9b25cea40",
  costSettlement: "231361ab-bc7b-40a9-97c0-f9f55a441245",
  operationsReport: "42d17ad4-3658-4fb9-ba6d-917615dc20af",
  devolutionSellerCenter: "97b0ed82-866e-45f7-bdd0-7b49b468cbfc",
  onTimeReport: "23498e4f-3451-4bd3-8128-40910b88952b",
  tracingPickingReport: "44b6b3db-af9d-4823-9a6d-5b239c1f2e7a",
  consolidatedDispatchReport: "5103216a-d356-4fcb-a0d6-125afb3042e2",
  freightModificationReport: "2e6d2518-5cc5-47fb-8f16-7aae21a4bda9",
  storeWithdrawalPending: "1ec0d2d7-ccbc-4353-994a-ce7d9f879a1b",
  controlTower: "53cd07ab-f8f5-44d0-961d-d0a51296acef",
  todayPerformance: "252972b4-8666-4962-845f-02d1f52cb1df",
  jokrStockControl: "ea170d6c-bdf3-4178-8785-2bdc163130af",
  historicalControlTower: "5f1913ea-08e6-4e27-92b7-95381bc5248f",
  sellerIncidence: "fad58866-8e12-4a3e-9347-11bf04d0b8a3",
  externalPicking: "36ab9785-e5d1-408b-9ba3-573b99c94f9a",
  capacityReport: "971771d7-c415-4cd4-be66-8a04eab93fa5",
  capacityReportLive: "e8c5ba46-b2f6-4ba3-8719-2dbefc57488c",
  jokrInventory: "2b2bb239-1cfd-4c1a-b743-4c77bb92918d",
  merkaoStockControl: "6a388872-f4a9-4701-8af0-9fdcbaa70d05",
  lossJokrDashboard: "fd020869-2de4-47b5-baa5-f2cfd0df2bb3",
  sellerCancellation: "0808db44-856e-42ac-95a8-2ded4ca21366",
  merkaoTripSettlement: "9e90f151-0406-4bb4-998b-2d0753edbbf6",
  orderRegister: "a4823b40-817f-4a9d-95d1-52d9016b5e9b",
  discountReport: "43ce84a1-8ddf-4001-b40d-4fa5c5a1d409",
  sellerCompliance: "efebcf7f-ca97-4db0-9def-8cec7022a440",
  leadtimeVtex: "d9c5ab93-a24e-4155-8d25-b396a4b7467b",
  inkafarmaOrders: "5002aaaf-95af-4f79-a2f5-716ac24c7dd3",
  stateOrders: "c4a6dec1-5dce-4bd3-a713-5d04399238bb",
  trxDad: "33fd6c87-c2a4-4af0-ba05-8377fd85964e",
  stateOrdersLive: "f3fa572d-a390-4945-9d34-be74d85fcea3",
  sellerControlTower: "5cd5efdc-222b-4df3-a230-847a1b16eac0",
};
